class CartNotification extends HTMLElement {
  constructor() {
    super();

    // CONFIG — customize these to match your header
    this.selectors = {
      cartIcon: ".c-header__action-icon", // your cart icon
      cartCount: ".c-header__cart-count", // your cart count bubble
    };

    this.notification = this; // <cart-notification> element itself

    this.onBodyClick = this.handleBodyClick.bind(this);

    // Close on ESC
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    // Close buttons inside popup
    this.querySelectorAll('button[type="button"]').forEach((btn) =>
      btn.addEventListener("click", () => this.close())
    );
  }

  // ---------------------------
  // OPEN + CLOSE BEHAVIOR
  // ---------------------------
  open() {
    this.classList.add("animate", "active");

    this.addEventListener(
      "transitionend",
      () => {
        this.focus();
        if (typeof trapFocus === "function") trapFocus(this);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.classList.remove("active");

    document.body.removeEventListener("click", this.onBodyClick);

    if (typeof removeTrapFocus === "function" && this.activeElement) {
      removeTrapFocus(this.activeElement);
    }
  }

  // ---------------------------
  // UPDATE NOTIFICATION CONTENT
  // ---------------------------
  renderContents(parsedState) {
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id);

      if (!container) return;

      const html = parsedState.sections[section.id];

      container.innerHTML = this.getSectionInnerHTML(html, section.selector);
    });

    this.updateCartBubble(parsedState);

    this.open();
  }

  // ---------------------------
  // UPDATE HEADER CART COUNT
  // ---------------------------
  updateCartBubble(parsedState) {
    const count = parsedState?.cart?.item_count;

    const icon = document.querySelector(this.selectors.cartIcon);
    if (!icon) return;

    let bubble = icon.querySelector(this.selectors.cartCount);

    // Create bubble if not present
    if (!bubble) {
      bubble = document.createElement("span");
      bubble.className = this.selectors.cartCount.replace(".", "");
      icon.style.position = "relative";
      icon.appendChild(bubble);
    }

    bubble.textContent = count;
    bubble.style.display = count > 0 ? "flex" : "none";
  }

  // ---------------------------
  // SECTIONS TO RENDER
  // ---------------------------
  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: "cart-notification-button",
      },
      {
        id: "cart-icon-bubble", // optional old section ID
      },
    ];
  }

  // Extract HTML from Shopify section response
  getSectionInnerHTML(html, selector = ".shopify-section") {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : html;
  }

  // Close when clicking outside popup
  handleBodyClick(evt) {
    if (!this.contains(evt.target)) {
      this.activeElement = document.activeElement;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
